import { Atom, Getter, Setter } from "jotai";
import { useAtomCallback } from "jotai/utils";

const getAtomValue = <T>(get: Getter, _set: Setter, anAtom: Atom<T>): T =>
  get(anAtom);

export const useGetAtom = () => useAtomCallback(getAtomValue);
